// src/pages/CustomFunnelPage.tsx
import React from "react";
import { Helmet } from "react-helmet";
import CustomFunnel from "../components/CustomFunnel/CustomFunnel";

const CustomFunnelPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>
          Business Sales Funnel — Whitelabel | The Blueprint Architect
        </title>
        <meta
          name="description"
          content="Plug-and-play whitelabel sales funnels built for businesses. We design, deploy and manage high-converting funnels that capture leads and generate predictable sales at scale."
        />
        <meta
          name="keywords"
          content="business sales funnel, whitelabel funnel, lead capture, sales funnel, funnel management, The Blueprint Architect, Adeolu Adegbemi"
        />
        <meta name="author" content="Adeolu Adegbemi" />

        {/* Open Graph */}
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://adeoluadegbemi.com/custom-funnel"
        />
        <meta
          property="og:title"
          content="Business Sales Funnel — Whitelabel | The Blueprint Architect"
        />
        <meta
          property="og:description"
          content="Get customers your own way. Done-for-you, high-converting sales funnels that capture leads, nurture prospects and turn them into paying customers."
        />
        <meta
          property="og:image"
          content="https://adeoluadegbemi.com/og-image-custom-funnel.jpg"
        />

        {/* Twitter */}
        <meta property="twitter:card" content="summary_large_image" />
        <meta
          property="twitter:url"
          content="https://adeoluadegbemi.com/custom-funnel"
        />
        <meta
          property="twitter:title"
          content="Business Sales Funnel — Whitelabel | The Blueprint Architect"
        />
        <meta
          property="twitter:description"
          content="Plug-and-play whitelabel funnels to scale customer acquisition and sales. We build and manage funnels so you can focus on growth."
        />
        <meta
          property="twitter:image"
          content="https://adeoluadegbemi.com/twitter-image-custom-funnel.jpg"
        />

        {/* Canonical & Robots */}
        <link rel="canonical" href="https://adeoluadegbemi.com/custom-funnel" />
        <meta name="robots" content="index, follow" />
      </Helmet>

      <main>
        <CustomFunnel />
      </main>
    </>
  );
};

export default CustomFunnelPage;
